import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { withAnalyticsEvents } from '@atlaskit/analytics-next';
import { DropdownItem, DropdownItemGroup, DropdownMenuStateless as DropdownMenu } from '@atlaskit/dropdown-menu';
import ChevronDownIcon from '@atlaskit/icon/glyph/chevron-down';
import EditorCloseIcon from '@atlaskit/icon/glyph/editor/close';
import { withFeatureFlags } from '@atlassian/mpac-ui';
import ImmutablePropTypes from '@atlassian/react-immutable-proptypes';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import CommonPropTypes from "../../../../../../../common/constants/proptypes/CommonPropTypes";
import { ANALYTICS_SUBJECT_ID_SIDEBAR_FACET, ANALYTICS_SUBJECT_ID_TOPBAR_FACET, EVENT_CHANNEL, EVENT_SOURCE, FacetCollapsedEvent, FacetExpandedEvent, OBJECT_TYPE_FILTER } from "../../../../../../constants/analytics/events";
import AddonDiscoveryPropTypes from "../../../../../../constants/proptypes/AddonDiscoveryPropTypes";
export var InternalFacetDropdownBase = /*#__PURE__*/function (_Component) {
  _inherits(InternalFacetDropdownBase, _Component);

  var _super = _createSuper(InternalFacetDropdownBase);

  function InternalFacetDropdownBase() {
    var _this;

    _classCallCheck(this, InternalFacetDropdownBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isOpen: false
    });

    _defineProperty(_assertThisInitialized(_this), "close", function () {
      _this.setState({
        isOpen: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOpenChange", function (_ref) {
      var isOpen = _ref.isOpen;

      // Work around an issue in Atlaskit where onOpenChange handler
      // is called when pressing Esc even when closed: https://ecosystem.atlassian.net/browse/AK-5044
      if (_this.state.isOpen === isOpen) {
        return;
      }

      _this.props.createAnalyticsEvent({
        eventType: isOpen ? FacetExpandedEvent : FacetCollapsedEvent,
        actionSubjectId: _this.props.facetBar === 'side' ? ANALYTICS_SUBJECT_ID_SIDEBAR_FACET : ANALYTICS_SUBJECT_ID_TOPBAR_FACET,
        objectType: OBJECT_TYPE_FILTER,
        objectId: _this.props.facetValue,
        source: EVENT_SOURCE,
        attributes: {
          currentPerspective: _this.props.perspective
        }
      }).fire(EVENT_CHANNEL);

      _this.setState({
        isOpen: isOpen
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleItemActivated", function (selection) {
      if (_this.props.closeOnItemSelected) {
        _this.close();
      }

      _this.props.onItemActivated(selection);
    });

    return _this;
  }

  _createClass(InternalFacetDropdownBase, [{
    key: "renderDropDownItemGroups",
    value: function renderDropDownItemGroups() {
      var _this2 = this;

      return Object.keys(this.props.items).map(function (group) {
        return /*#__PURE__*/React.createElement(DropdownItemGroup, {
          key: group,
          title: group.toUpperCase()
        }, _this2.props.items[group].map(function (item) {
          return /*#__PURE__*/React.createElement(DropdownItem, {
            key: item.facetValue,
            id: item.facetValue,
            isSelected: item.isChecked,
            onClick: function onClick() {
              return _this2.handleItemActivated({
                item: item
              });
            }
          }, item.content);
        }));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var iconAfter = this.props.hasSelectedItem ? /*#__PURE__*/React.createElement("span", {
        onClick: this.props.onRemoveClick
      }, /*#__PURE__*/React.createElement(EditorCloseIcon, {
        label: "Remove selected"
      })) : /*#__PURE__*/React.createElement(ChevronDownIcon, null);
      var buttonProps = {
        component: 'div',
        appearance: 'subtle',
        isSelected: this.state.isOpen,
        iconAfter: iconAfter
      };

      if (this.props.facetBar === 'side') {
        buttonProps = _objectSpread(_objectSpread({}, buttonProps), {}, {
          shouldFitContainer: true,
          style: {
            textAlign: 'left'
          }
        });
      } // MC-731 facet = categories && sortingLogicForCategory = usage-and-alphabetical
      // items = {popular: List of popular categories , all: List of all categories}


      if (!Immutable.List.isList(this.props.items)) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DropdownMenu, {
          shouldFitContainer: this.props.facetBar === 'side',
          isOpen: this.state.isOpen,
          onOpenChange: this.handleOpenChange,
          shouldFlip: false,
          triggerType: "button",
          triggerButtonProps: buttonProps,
          trigger: this.props.label
        }, this.renderDropDownItemGroups()));
      } else return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DropdownMenu, {
        shouldFitContainer: this.props.facetBar === 'side',
        isOpen: this.state.isOpen,
        items: [{
          items: this.props.items.toArray()
        }],
        onItemActivated: this.handleItemActivated,
        onOpenChange: this.handleOpenChange,
        shouldFlip: false,
        triggerType: "button",
        triggerButtonProps: buttonProps
      }, this.props.label));
    }
  }]);

  return InternalFacetDropdownBase;
}(Component);

_defineProperty(InternalFacetDropdownBase, "propTypes", {
  facetBar: PropTypes.oneOf(['top', 'side']),
  closeOnItemSelected: PropTypes.bool,
  createAnalyticsEvent: PropTypes.func.isRequired,
  filters: CommonPropTypes.filters.isRequired,
  facetValue: PropTypes.string.isRequired,
  hasSelectedItem: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  items: PropTypes.oneOfType([ImmutablePropTypes.list, PropTypes.object]).isRequired,
  onItemActivated: PropTypes.func.isRequired,
  onRemoveClick: PropTypes.func.isRequired,
  perspective: AddonDiscoveryPropTypes.perspective.isRequired
});

export default withAnalyticsEvents()(withFeatureFlags(InternalFacetDropdownBase));